(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["swiper-product-slider"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.mySwiper', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 15,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    breakpoints: {
      640: { 
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      1024: { 
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    }
  });

  // ✅ AJAX Add to Cart (with "Added ✅" feedback)
  document.querySelectorAll('.add-to-cart-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(this);
      const button = this.querySelector('.add-to-cart-btn');

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        button.textContent = 'Added';
        setTimeout(() => {
          button.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" class="icon-cart" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-1.35 2.7a1 1 0 00.9 1.3h11.1m-10.1 0a1 1 0 100 2 1 1 0 000-2zm10 0a1 1 0 100 2 1 1 0 000-2z" />
            </svg>
            Add
          `;
        }, 2000);

        // Optionally update cart count
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const count = cart.item_count;
            const cartBadge = document.querySelector('.cart-count-bubble');
            if (cartBadge) cartBadge.textContent = count;
          });
      })
      .catch(err => console.error('Add to cart error:', err));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
